export default __webpack_public_path__ + "img/bLtlybuG.033fea23.svg";